import script from "./edit.vue?vue&type=script&setup=true&lang=js"
export * from "./edit.vue?vue&type=script&setup=true&lang=js"

import "./edit.vue?vue&type=style&index=0&id=54ac69ad&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ac69ad"]])

export default __exports__